module.exports = __webpack_public_path__ + "img/historic-measurements.0148d9c6.svg";